import { render, staticRenderFns } from "./UserRead.vue?vue&type=template&id=165dacb0&scoped=true&"
import script from "./UserRead.vue?vue&type=script&lang=js&"
export * from "./UserRead.vue?vue&type=script&lang=js&"
import style0 from "./UserRead.vue?vue&type=style&index=0&id=165dacb0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165dacb0",
  null
  
)

export default component.exports